<app-header-hs1 titulo="Monitoramento" (eventSave)="save()" (eventCancel)="voltar()" [deletavel]="deletavel" [editavel]="true" (eventDelete)="delete()"/>

<ion-content [fullscreen]="true">
  <ion-list [inset]="true">
    <form #form="ngForm">
      <ion-item >
        <ion-select required [compareWith]="compareWith" interface="popover" name="projeto" label-placement="floating" label="Projeto" [(ngModel)]="entidade.projeto">
          <ion-select-option *ngFor="let fu of projetos" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
        <ion-icon slot="end" color="su" name="add-circle" (click)="addProjeto()"/>
      </ion-item>

      <ion-item >
        <ion-select [compareWith]="compareWith" minlength="1"
                    required [multiple]="true" interface="popover" name="metodos"
                    label-placement="floating" label="Métodos" [(ngModel)]="entidade.metodos">
          <ion-select-option *ngFor="let fu of entidade.projeto?.metodosOrdenados" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>

      </ion-item>
<!--      <ion-item >-->
<!--        <ion-note color="medium">-->
<!--            <span style="font-size: small">Para mais de um método, adicione um novo monitoramento</span>-->
<!--        </ion-note>-->
<!--      </ion-item>-->

      <app-selecao-local [(local)]="entidade.local"/>

      <ion-item >
        <ion-select [compareWith]="compareWith"  interface="popover" name="campanha" label-placement="floating" label="Campanha" [(ngModel)]="entidade.campanha">
          <ion-select-option *ngFor="let fu of entidade.projeto?.campanhas" [value]="fu">{{ fu.nome }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item >
        <ion-select  interface="popover" name="estacao" label-placement="floating" label="Estação" [(ngModel)]="entidade.estacao">
          <ion-select-option *ngFor="let fu of estacoes" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-textarea name="obs" [(ngModel)]="entidade.obs"  label-placement="floating" label="Observações"/>
      </ion-item>

      <ion-item *ngIf="exibeFaseLunar">
        <ion-select  interface="popover" name="faseLunar" label-placement="floating" label="Fase Lunar" [(ngModel)]="entidade.faseLunar">
          <ion-select-option *ngFor="let fu of fasesLunares" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.INDICADOR_ESTRATO)">
        <ion-select  interface="popover" name="faseLunar" label-placement="floating" label="Estrato" [(ngModel)]="entidade.estrato">
          <ion-select-option *ngFor="let fu of estratos" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.NOME_TRANSECTO)">
        <ion-input type="text" name="nomeTransecto" [(ngModel)]="entidade.nomeTransecto"  label-placement="floating" label="Nome Transecto"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.PONTO_CAPTURA)">
        <ion-input type="text" name="pontoCaptura" [(ngModel)]="entidade.nomePostoCaptura"  label-placement="floating" label="Nome Ponto Captura"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.DISTANCIA_PERCORRIDA)">
        <ion-input type="number" name="distanciaPercorrida" [(ngModel)]="entidade.distanciaPercorrida"
                   label-placement="floating" label="Distância Percorrida (m)"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.NOME_ARMADILHA)">
        <ion-input type="text" name="nomeArmadilha" [(ngModel)]="entidade.nomeArmadilha"
                   label-placement="floating" label="Nome da Armadilha"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.QUANTIDADE_PARCELAS)">
        <ion-input type="number" name="qtdeParcelas" [(ngModel)]="entidade.qtdeParcelas"
                   label-placement="floating" label="Quantidade de Parcelas"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.QUANTIDADE_ARMADILHA)">
        <ion-input type="number" name="qtdeArmadilhas" [(ngModel)]="entidade.qtdeArmadilhas"
                   label-placement="floating" label="Quantidade de Armadilhas"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.TAMANHO_MALHA)">
        <ion-input type="number" name="qtdeArmadilhas" [(ngModel)]="entidade.tamanhoMalha"
                   label-placement="floating" label="Tamanho da Malha"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.QUANTIDADE_LANCES)">
        <ion-input type="number" name="qtdeLances" [(ngModel)]="entidade.qtdeLances"
                   label-placement="floating" label="Quantidade de Lances"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.QUANTIDADE_PASSADAS)">
        <ion-input type="number" name="qtdePassadas" [(ngModel)]="entidade.qtdePassadas"
                   label-placement="floating" label="Quantidade de Passadas"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.NUMERO_DISPAROS)">
        <ion-input type="number" name="numeroDisparos" [(ngModel)]="entidade.numeroDisparos"
                   label-placement="floating" label="Número de Disparos"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.INDICADOR_POSICAO)">
        <ion-select  interface="popover" name="posicao" label-placement="floating" label="Posição/Lado" [(ngModel)]="entidade.posicao">
          <ion-select-option *ngFor="let fu of posicoes" [value]="fu">{{ fu }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.NUMERO_REDE)">
        <ion-input type="number" name="numeroRede" [(ngModel)]="entidade.numeroRede"
                   label-placement="floating" label="Número de Redes"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.COMPRIMENTO_REDE)">
        <ion-input type="number" name="comprimentoRede" [(ngModel)]="entidade.comprimentoRede"
                   label-placement="floating" label="Comprimento da Rede (m)"/>
      </ion-item>

      <ion-item *ngIf="exibir(AtributoMonitoramento.ALTURA_REDE)">
        <ion-input type="number" name="alturaRede" [(ngModel)]="entidade.alturaRede"
                   label-placement="floating" label="Altura da Rede (m)"/>
      </ion-item>
    </form>
  </ion-list>
</ion-content>
<app-rodape [exibirBotoes]="false"/>
